const PLURAL_SUFFIXES = ['יות', 'ות', 'ים', 'ה'];

export interface OpenListLine {
  id: number;
  text: string;
}

export function normalizeListText(value: string): string {
  return value
    .normalize('NFKC')
    .replace(/[\u0591-\u05C7]/g, '')
    .replace(/['"׳״`´]/g, '')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .trim()
    .replace(/ +/g, ' ');
}

function isLetter(char: string): boolean {
  return /\p{L}/u.test(char);
}

function hasWordBoundary(text: string, index: number): boolean {
  return index >= text.length || !isLetter(text.charAt(index));
}

function matchesOneName(listText: string, productName: string): boolean {
  const list = normalizeListText(listText);
  const product = normalizeListText(productName);
  if (!list || !product) return false;
  if (product.startsWith(list) && hasWordBoundary(product, list.length)) return true;

  for (const suffix of PLURAL_SUFFIXES) {
    if (!list.endsWith(suffix)) continue;
    const stem = list.slice(0, -suffix.length);
    if (stem.length < 2 || !product.startsWith(stem)) continue;
    const rest = product.slice(stem.length);
    if (hasWordBoundary(rest, 0)) return true;
    for (const ending of PLURAL_SUFFIXES) {
      if (rest.startsWith(ending) && hasWordBoundary(rest, ending.length)) return true;
    }
  }

  return false;
}

export function matchingOpenLines(productNames: string[], lines: OpenListLine[]): OpenListLine[] {
  const names = productNames.map((name) => name.trim()).filter((name) => name.length > 0);
  return lines.filter((line) => names.some((name) => matchesOneName(line.text, name)));
}
